






















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { ITaxTag } from "@/models/tax";
import { TaxTagBaseTypesMap } from "@/data/enums/tax";

@Component({
  components: {
    "tax-tag-locations": () =>
      import("@/components/app/global/tax/tags/taxTagLocations.vue")
  }
})
export default class TaxTagsGridItem extends Vue {
  // Props

  @Prop({ default: undefined })
  public taxTag?: ITaxTag;

  @Prop({ default: false })
  public canUpdate!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public readonly isChecked!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;

  public get appliesTo() {
    if (!this.taxTag) return "";
    const taxTagBaseTypesMap = TaxTagBaseTypesMap();
    return taxTagBaseTypesMap[this.taxTag?.base_type]?.label;
  }

  public get locationsCount() {
    if (!this.taxTag) return 0;
    return this.taxTag.locations?.length;
  }

  public get hasSecondaryRate() {
    if (!this.taxTag) return false;
    const { amount, company_amount, type, company_type } = this.taxTag;
    return !(company_type === type && company_amount === amount);
  }

  public handleClick() {
    this.$attrs["is-selectable"]
      ? this.$emit("check", { isChecked: !this.isChecked, taxTag: this.taxTag })
      : this.$emit("update");
  }

  public handleCtaClick() {
    if (this.$attrs["is-selectable"]) {
      this.$emit("update");
      return;
    }

    this.handleClick();
  }
}
